import React from "react"
import GoBackIcon from "../../atoms/buttons/GoBackIcon.atom"
import { Skeleton } from "../../atoms/misc/Skeleton.atom"
import PropTypes from "prop-types"

export default function MainTitle(props) {
  const {
    subtitleLoading,
    customSubtitle,
    subtitle,
    subtitleAccessory,
    title,
    className,
    goBack,
  } = props

  const renderSubtitle = () => {
    if (subtitleLoading) {
      return (
        <div
          className="main-title__subtitle-skeleton-wrap"
          aria-busy="true"
          aria-label="Cargando subtítulo"
        >
          <Skeleton height="24px" width="100%" className="border-round" />
        </div>
      )
    }

    if (customSubtitle) {
      return <>{subtitle}</>
    }

    const isAnimatedString =
      typeof subtitle === "string" && subtitle.trim().length > 0

    const animatedText =
      isAnimatedString ?
        <span
          className="main-title__subtitle-text main-title__subtitle-text--reveal"
          key={subtitle}
        >
          {subtitle}
        </span>
      : subtitle

    if (subtitleAccessory) {
      return (
        <h2 className="main-title__subtitle-with-accessory">
          <span className="main-title__subtitle-text-container">
            {animatedText}
          </span>
          {subtitleAccessory}
        </h2>
      )
    }

    return <h2 className="">{animatedText}</h2>
  }

  return (
    <>
      <div className={`${className} flex align-items-center`}>
        {goBack ?
          <GoBackIcon />
        : null}
        <div className="flex flex-column">
          <h1 className="mb-0" style={{ fontSize: "28px" }}>
            {title}
          </h1>
          {renderSubtitle()}
        </div>
      </div>
    </>
  )
}

MainTitle.propTypes = {
  goBack: PropTypes.bool,
  icon: PropTypes.element,
  title: PropTypes.string,
  className: PropTypes.string,
  subtitleLoading: PropTypes.bool,
  customSubtitle: PropTypes.bool,
  subtitleAccessory: PropTypes.node,
}
